"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var REGIONS = {
  northAmerica: 'NA',
  latinAmerica: 'LA',
  emea: 'EMEA',
  asia: 'APA'
};
var _default = REGIONS;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./lib/config/regions.js
// module id = 274
// module chunks = 0